export default {
	name: 'PuppySellingView',
	components: {},
	directive: {},
	filters: {},
	mixins: [],
	props: {},
	data() {
		return {
		}
	},
	computed: {},
	watch: {},
	created() {},
	methods: {},
	// third party libraries
}